import React from "react";

// Components
import CheckInTag from "./CheckInTag";

// STYLES
import "./CheckInTagGroup.scss";

interface ICheckInTagGroupProps {
    className?: string;
    tags: string[];
}

const CheckInTagGroup: React.FC<ICheckInTagGroupProps> = ({
    className = "",
    tags,
}) => {
    return (
        <div className={`CheckInTagGroup ${className}`}>
            {tags.map((tag: string, idx: number) => {
                return <CheckInTag key={idx} tag={tag} />;
            })}
        </div>
    );
};

export default CheckInTagGroup;
